import { useTheme } from '@mui/material'
import { useSceneShapeMarker } from '@editorHooks'
import { getHorizontalClipPlaneOutlinePoints, IMPORT_HELPER_CLIP_PLANES } from './utils'

const ClipPlaneImportHelperPreview = (): null => {
  const { scenePalette } = useTheme()
  const [gltfPlane, allPlane] = IMPORT_HELPER_CLIP_PLANES

  useSceneShapeMarker({
    points: getHorizontalClipPlaneOutlinePoints(gltfPlane.point),
    enabled: true,
    color: scenePalette.highlightDark as string,
    lineWidth: 2,
    renderOrder: 101,
  })

  useSceneShapeMarker({
    points: getHorizontalClipPlaneOutlinePoints(allPlane.point),
    enabled: true,
    color: scenePalette.highlightDark as string,
    lineWidth: 2,
    dashed: true,
    dashSize: 0.6,
    gapSize: 0.35,
    renderOrder: 101,
  })

  return null
}

export default ClipPlaneImportHelperPreview
